import { CacheInterceptor as NestCacheInterceptor } from '@nestjs/cache-manager';
import { CallHandler, ExecutionContext } from '@nestjs/common';
import { map, Observable } from 'rxjs';

export class CacheInterceptor extends NestCacheInterceptor {
  public override async intercept(context: ExecutionContext, next: CallHandler): Promise<Observable<any>> {
    const observable = await super.intercept(context, next);
    return observable.pipe(
      map((data) => {
        if (!data.count && !data.documents) return data;
        const response = context.switchToHttp().getResponse();
        response.header('X-Total-Count', data.count);
        return data.documents;
      })
    );
  }
}
